
import { sendRequest } from '../../config';

export interface addLogParams {
    /** parametros obligatorios */
    csistema: string;
    clog: string;
    cpais: string;
    xdescripcion: string

    /** parametros opcionales */
    xdato?: string;
    iestado?: string;
    ccedasegrado?: string;
    cdoctor?: string;
    cclinica?: string;
}

export interface dataAddLog {
    description?: string;
    cconsecutivo?: string;
}

export const addLog = async (params: addLogParams): Promise<dataAddLog> => {
    const ENDPOINT = 'wslog/add';
    return sendRequest({
        method: 'post',
        path: ENDPOINT,
        body: params,
    });
};